const TYPE = 'SET_GROUPS_VISIBLE';

const action = (visible) => (dispatch) => dispatch({ type: TYPE, payload: visible });

export default { action, TYPE };
